module.exports = __webpack_public_path__ + "static/media/pm_salle_spectacle.c043b484.jpg";